var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from "react";
import * as Styled from "./StripePaymentElementStyles";
import { useStripe, useElements, PaymentElement, LinkAuthenticationElement, } from "@stripe/react-stripe-js";
import { Spacer } from "@gcp-artifact/compass/lib/components";
import Button from "@gcp-artifact/compass/lib/components/updated/button";
import useAdminStore from "@/services/store/useAdminStore";
import translate from "@/utilities/i18n/getTranslate";
import { k } from "@/utilities/i18n";
import { MixpanelEvents } from "@/utilities/mixpanel/events";
var options = {
    layout: "accordion",
};
var StripePaymentElement = function (_a) {
    var redirectUrl = _a.redirectUrl, onComplete = _a.onComplete;
    var currentUser = useAdminStore().adminStore.currentUser;
    var stripe = useStripe();
    var elements = useElements();
    var _b = __read(useState(), 2), message = _b[0], setMessage = _b[1];
    var _c = __read(useState(false), 2), isLoading = _c[0], setIsLoading = _c[1];
    var handleSubmit = function (e) { return __awaiter(void 0, void 0, void 0, function () {
        var error, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    e.preventDefault();
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    if (!stripe || !elements) {
                        // Stripe.js has not yet loaded.
                        // Make sure to disable form submission until Stripe.js has loaded.
                        return [2 /*return*/];
                    }
                    setIsLoading(true);
                    return [4 /*yield*/, stripe.confirmSetup({
                            elements: elements,
                            confirmParams: {
                                // Make sure to change this to your payment completion page
                                return_url: redirectUrl ||
                                    "".concat(window.location.origin, "/dashboard/billing/configuration"),
                            },
                        })];
                case 2:
                    error = (_a.sent()).error;
                    // This point will only be reached if there is an immediate error when
                    // confirming the payment. Otherwise, your customer will be redirected to
                    // your `return_url`. For some payment methods like iDEAL, your customer will
                    // be redirected to an intermediate site first to authorize the payment, then
                    // redirected to the `return_url`.
                    if (!error) {
                        onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                    }
                    if (error.type === "card_error" || error.type === "validation_error") {
                        setMessage(error.message);
                    }
                    else {
                        setMessage("An unexpected error occured.");
                    }
                    setIsLoading(false);
                    return [3 /*break*/, 4];
                case 3:
                    error_1 = _a.sent();
                    setIsLoading(false);
                    MixpanelEvents.errorEvent("Error while submitting stripe payment method", {
                        error: error_1,
                    });
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Styled.StripePaymentElement, null,
        React.createElement("form", { id: "payment-form", onSubmit: handleSubmit },
            React.createElement(LinkAuthenticationElement, { id: "link-authentication-element", options: { defaultValues: { email: currentUser === null || currentUser === void 0 ? void 0 : currentUser.email } } }),
            React.createElement(PaymentElement, { id: "payment-element", options: options }),
            React.createElement(Spacer, { size: "s" }),
            React.createElement(Button, { variant: "primary", fullWidth: true, id: "submit", disabled: isLoading || !stripe || !elements, isPending: isLoading }, translate(k.A_continue)),
            message && React.createElement("div", { id: "payment-message" }, message))));
};
export default StripePaymentElement;
//# sourceMappingURL=data:application/json;base64,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